<div class="pt-6">
  <aiwyn-logo [height]="60" [extraClasses]="'client-logo'" (click)="goBack()"></aiwyn-logo>
</div>

<div class="authentication-body">
  <h2>Check your email</h2>

  <p class="body-300 color-gray-100 text-center">
    To sign in password-free, tap the button in the email sent to {{ emailAddress }}.
  </p>

  <p class="small-300">
    Can't find the email? Check your spam filter!
  </p>
</div>

<app-full-client-portal-footer class="px-6 pb-6"></app-full-client-portal-footer>
